<template>
    <transition name="cookie-slide">
        <div v-if="!hasUserMadeChoice" class="cookie-modal">
            <div class="cookie-content">

                <h3>{{ translation('titolo.cookie.moale.001') }}</h3>
                <p>{{ translation('titolo.cookie.moale.002') }}</p>

                <p>
                    <label>
                        <input type="checkbox" id="tech" checked disabled />
                        <span>{{ translation('titolo.cookie.moale.003') }}</span>
                    </label><br />
                    <span>{{ translation('titolo.cookie.moale.004') }}</span>
                </p>

                <p>
                    <label>
                        <input type="checkbox" id="analytics" v-model="cookieChoices.analytics">
                        <span>{{ translation('titolo.cookie.moale.005') }}</span>
                    </label><br />
                    <span>{{ translation('titolo.cookie.moale.006') }}</span>

                </p>

                <p>

                    <label>
                        <input type="checkbox" id="marketing" v-model="cookieChoices.marketing">
                        <span>{{ translation('titolo.cookie.moale.007') }}</span>
                    </label><br />
                    <span>{{ translation('titolo.cookie.moale.008') }}</span>
                </p>

                <div class="cookie-actions">
                    <button @click="acceptSelected" class="btn-accept">{{ translation('btn.cookie.selected') }}</button>
                    <button @click="acceptAll" class="btn-primary">{{ translation('btn.cookie.all') }}</button>
                </div>

            </div>
        </div>
    </transition>
</template>

<script>
import Cookies from 'js-cookie'
import translationStore from '@/store/translations'

// Chiave unica per lo storage
const COOKIE_STORAGE_KEY = 'cookies_preferences'
// Scadenza a 6 mesi (circa 182 giorni)
const COOKIE_EXPIRY_DAYS = 182

export default {
  name: 'CookieConsent',
  data () {
    return {
      cookieChoices: {
        technical: true,
        analytics: false,
        marketing: false
      },
      hasUserMadeChoice: false
    }
  },
  mounted () {
    this.checkStoredPreferences()
  },
  computed: {
    translation () {
      return translationStore.getters.traduzione
    }
  },
  methods: {
    checkStoredPreferences () {
      const stored = Cookies.get(COOKIE_STORAGE_KEY)

      if (stored) {
        try {
          // Unisce i dati salvati con lo stato predefinito (garantendo technical: true)
          const parsed = JSON.parse(stored)
          this.cookieChoices = { ...this.cookieChoices, ...parsed }
          this.hasUserMadeChoice = true
          // Emette l'evento per informare subito l'app (es. main.js)
          this.$root.$emit('cookies-updated', this.cookieChoices)
        } catch (e) {
          // console.error('Errore nel parsing del cookie di consenso', e)
        }
      }
    },

    saveAndClose () {
      // Salviamo solo analytics e marketing, technical è implicito
      const dataToSave = {
        analytics: this.cookieChoices.analytics,
        marketing: this.cookieChoices.marketing
      }

      // Imposta il cookie HTTP con scadenza a 6 mesi
      Cookies.set(COOKIE_STORAGE_KEY, JSON.stringify(dataToSave), {
        expires: COOKIE_EXPIRY_DAYS,
        secure: process.env.NODE_ENV === 'production',
        sameSite: 'Lax'
      })

      this.hasUserMadeChoice = true

      // Emette evento per notificare al resto dell'app
      this.$root.$emit('cookies-updated', this.cookieChoices)
    },

    acceptSelected () {
      this.saveAndClose()
    },

    acceptAll () {
      this.cookieChoices.analytics = true
      this.cookieChoices.marketing = true
      this.saveAndClose()
    }
  }
}
</script>

<style scoped>
/*
 * Aggiornato il layout CSS per utilizzare Flexbox per l'allineamento,
 * risolvendo i problemi di visualizzazione dei checkbox all'interno della struttura <table> precedente.
 */
.cookie-modal {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: white;
    color: #333;
    padding: 20px;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.15);
    z-index: 9999;
    text-align: left;
}

.cookie-content {
    max-width: 900px;
    margin: 0 auto;
}

h3 {
    color: #007bff;
    margin-top: 0;
}

.btn-accept,
.btn-primary {
    padding: 10px 18px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    transition: background-color 0.2s;
}

.btn-accept {
    background-color: #f0f0f0;
    color: #333;
}

.btn-primary {
    background-color: #4CAF50;
    color: white;
    margin-left: 10px;
}

.btn-primary:hover {
    background-color: #45a049;
}

.btn-accept:hover {
    background-color: #e0e0e0;
}

/* Transizioni opzionali */
.cookie-slide-enter-active,
.cookie-slide-leave-active {
    transition: transform 0.5s ease;
}

.cookie-slide-enter,
.cookie-slide-leave-to {
    transform: translateY(100%);
}
</style>
